import { ICellularDeviceActivationViewModel } from '../cellular-device-activation/icellular-device-activation.model';
import { ITypedResponse } from '../../src/typings/ITypedResponse';
import { ICellularDeviceDeactivationService } from './icellular-device-deactivation.service';
import { Injectable } from '@angular/core';
import { ProxyService } from '../proxy/ProxyService';

@Injectable({
    providedIn: 'root'
})
export class CellularDeviceDeactivationService implements ICellularDeviceDeactivationService {
    public static $name: string = 'cellularDeviceDeactivationService';

    constructor(
        private proxyService: ProxyService
    ) {
    }

    public sendDeactivationRequest(viewModel: ICellularDeviceActivationViewModel) {
        return this.proxyService.request({
            data: viewModel,
            endPoint: 'cellularDeviceActivation',
            route: 'sendDeactivationRequest',
        }).as<ITypedResponse<string>>();
    }
}
